import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import {List, ListItem} from 'material-ui/List'

import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		transaction: doc(state, props.id)
	})
)

export class PaymentMethodIcon extends Component{
	render(){
		let { props } = this
		return(
			<div style={{width:"45px"}}>
				{props.transaction.paymentMethod == "QuickBooks" || (!props.transaction.paymentMethod && props.transaction.qbid) ?
					<img
						src="/static/img/bank-green.png"
						style={{
							float: "left"
							, width: "24px"
							, position: "relative"
							, left: "-1px"
						}}
					/>
					:
					props.transaction.paymentMethod == "Credit/ATM card" || props.transaction.paymentMethod == "Card" ?
						<img
							src="/static/img/ccard_green.png"
							style={{
								float: "left"
								, width: "24px"
								, position: "relative"
								, left: "-1px"
							}}
						/>
					:
					props.transaction.paymentMethod == "Paper check" ?
						<img
							src="/static/img/check_green.png"
							style={{
								float: "left"
								, width: "24px"
								, position: "relative"
								, left: "-1px"
							}}
						/>
					:
					props.transaction.paymentMethod == "Paypal" ?
						<img
							src="/static/img/ppal_green.png"
							style={{
								float: "left"
								, width: "24px"
								, position: "relative"
								, left: "-1px"
							}}
						/>
					:
					""
				}
			</div>
		)
	}
}
export default connect(select)(PaymentMethodIcon)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/PaymentMethodIcon.js